/**
 * JRL Merch catalog (generated from the spreadsheet export).
 *
 * DO NOT EDIT THIS FILE MANUALLY.
 * Generated by: scripts/jrl-merch/generate-catalog.js
 */

export const JRL_MERCH_CATALOG = [
  {
    id: 'AXIMA_SWEATSHIRT_SWEATSHIRT_UNISEX',
    model: 'Axima Sweatshirt',
    category: 'Sweatshirt',
    gender: 'Unisex',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'BLACK',
        colorLabel: 'Black',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/AYKZipIV275D7mOyd1ytW/9fcb435f79e41885be0a56a02feeb292/976809_23_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/4KwQEvPQrEXmTh3kpFxDD1/491944cfffcd0738dd7dd120ac097643/976809_23_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/AYKZipIV275D7mOyd1ytW/9fcb435f79e41885be0a56a02feeb292/976809_23_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/axima-sweatshirt-blk976809-976809-0000121059?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_976809',
        imageAlt: undefined,
      },
      {
        id: 'GREY',
        colorLabel: 'Grey',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/LnNbMAEFtPboOB5NnhhLd/90dece1fd0ab1d2cc19971625b562773/976819_21_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3KehlJmI9fBblBSjxg0yFE/b7d38c30e6538f25ba9eee975bdb189f/976819_21_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/LnNbMAEFtPboOB5NnhhLd/90dece1fd0ab1d2cc19971625b562773/976819_21_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/axima-sweatshirt-gry976819-976819-0000121059?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_976819',
        imageAlt: undefined,
      },
      {
        id: 'NAVY',
        colorLabel: 'Navy',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/ukPSHYVLjrI6tldsgzXv9/cfd4d05caf2f020e39c4088dfd566603/976807_22_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2bl1dkTsgnzWm0F8ZSaPnK/bc7bfc71fd38db4c58d7714f6abeeed4/976807_22_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/ukPSHYVLjrI6tldsgzXv9/cfd4d05caf2f020e39c4088dfd566603/976807_22_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/axima-sweatshirt-nav976807-976807-0000121059?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_976807',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'BOOST_ECO_T_SHIRT_T_SHIRT_UNISEX',
    model: 'Boost Eco T-Shirt',
    category: 'T-Shirt',
    gender: 'Unisex',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'BLACK',
        colorLabel: 'Black',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/76Gr2UZAZ9aBfXvWVICehN/7814aa0bdc4b69bfb8ea65d7411c6814/91880900_27_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2z9OYVvHwKk8QEWtSWoZv4/9872d561685f7dd807e0b9b4f40a93be/91880900_27_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/76Gr2UZAZ9aBfXvWVICehN/7814aa0bdc4b69bfb8ea65d7411c6814/91880900_27_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/boost-eco-t-shirt-blk-ss-5-pz-91880900-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_91880900',
        imageAlt: undefined,
      },
      {
        id: 'CARDINAL',
        colorLabel: 'Cardinal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1OZVpFVCaL8qowwPriSN0R/68f65997ba2e36b08ce043b4606edc55/91881400_28_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2U5qHgpWSoC5J1YtYZuryG/2c5b8ce60139562621aba24940119980/91881400_28_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1OZVpFVCaL8qowwPriSN0R/68f65997ba2e36b08ce043b4606edc55/91881400_28_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/boost-eco-t-shirt-crd-ss-5-pz-91881400-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_91881400',
        imageAlt: undefined,
      },
      {
        id: 'GREEN',
        colorLabel: 'Green',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2DJnUrbyauMKFRlFiSGFC4/6580939c3f9ee115f8f1a8db9cdc7794/91880400_26_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6IhXzyOQPLIu9xlgU42GgV/daecdaf1edc180b44d75e21cd38dbd61/91880400_26_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2DJnUrbyauMKFRlFiSGFC4/6580939c3f9ee115f8f1a8db9cdc7794/91880400_26_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/boost-eco-t-shirt-grn-ss-5-pz-91880400-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_91880400',
        imageAlt: undefined,
      },
      {
        id: 'GREY_MELANGE',
        colorLabel: 'Grey / Melange',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/fflugwQAfrZADF6q8zBW0/45ed65f348e9bc8f846663e13c58f6df/91881900_29_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3wrvOaktgWP4dRWDiqjp0u/c7afe8b7b27b578ffb67d30496020221/91881900_29_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/fflugwQAfrZADF6q8zBW0/45ed65f348e9bc8f846663e13c58f6df/91881900_29_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/boost-eco-t-shirt-gry-mel-ss-5-pz-91881900-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_91881900',
        imageAlt: undefined,
      },
      {
        id: 'NAVY',
        colorLabel: 'Navy',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/79xZiDlW9Rjic9YjX0JnuH/fd82033ffadc4cca24c4438752f03a1a/91880700_24_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3v6NjNDegS4xuN7A5hLlUR/4662577ee66d19d7be047f9b3903d3c0/91880700_24_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/79xZiDlW9Rjic9YjX0JnuH/fd82033ffadc4cca24c4438752f03a1a/91880700_24_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/boost-eco-t-shirt-nav-ss-5-pz-91880700-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_91880700',
        imageAlt: undefined,
      },
      {
        id: 'ROYAL',
        colorLabel: 'Royal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6Pk5bQBZzGU3xbUJQeIzVw/7ae951d1c88b6b37382bead60ea79c9b/91880300_25_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/4qva9AB0vrV4Y0SYlX8S3S/e1e5c681d4958e6db449c988c2a94ff8/91880300_25_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6Pk5bQBZzGU3xbUJQeIzVw/7ae951d1c88b6b37382bead60ea79c9b/91880300_25_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/boost-eco-t-shirt-roy-ss-5-pz-91880300-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_91880300',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'ELBRUS_RAIN_JACKET_RAIN_JACKET_UNISEX',
    model: 'Elbrus Rain Jacket',
    category: 'Rain Jacket',
    gender: 'Unisex',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'BLACK_DARK_GREY',
        colorLabel: 'Black / Dark Grey',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3fa9m3f12b7fil8zaOrqyh/af199a29efee51d85515648d8c5f4a96/812809_8_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3KBmClQCjWv2sNZv6PuiB6/3b46c5f9a0737d38c5df2f7ffb553336/812809_8_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3fa9m3f12b7fil8zaOrqyh/af199a29efee51d85515648d8c5f4a96/812809_8_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/elbrus-full-length-zip-rainjacket-blk-dgry812809-812809-0000121059-6?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_812809',
        imageAlt: undefined,
      },
      {
        id: 'NAVY_LIGHT_NAVY',
        colorLabel: 'Navy / Light Navy',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/7fQ9nV7HxogfQuP7hMZ9j8/13a47f133817188057674a3a24f01371/812807_6_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3jmxSjw8XYcmzDRxREc1cF/e92f6b76431e17674467f6021c1923d5/812807_6_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/7fQ9nV7HxogfQuP7hMZ9j8/13a47f133817188057674a3a24f01371/812807_6_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/elbrus-full-length-zip-rainjacket-nav-lnav812807-812807-0000121059-121060-1?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_812807',
        imageAlt: undefined,
      },
      {
        id: 'ROYAL_DARK_ROYAL',
        colorLabel: 'Royal / Dark Royal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6kJP450LCMaMtURhSTp0CC/1956b3d62645b45c55f4ecc0a650678f/812803_7_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/75elMzXRtDt0kMprhOeGOx/fa111187cb3b8eaba42fb89e9fb2ee4e/812803_7_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6kJP450LCMaMtURhSTp0CC/1956b3d62645b45c55f4ecc0a650678f/812803_7_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/elbrus-full-length-zip-rainjacket-roy-droy812803-812803-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_812803',
        imageAlt: undefined,
      },
      {
        id: 'STONE_GREY',
        colorLabel: 'Stone Grey',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1mmmJ1iPAXnrTFpyeJIwMq/0a1650485000784de8f937841bea85ea/812842_9_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2LIj32d8bC6RlsVicHOLnB/7d591b68247eea7fd2f080dba7a305e8/812842_9_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1mmmJ1iPAXnrTFpyeJIwMq/0a1650485000784de8f937841bea85ea/812842_9_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/elbrus-full-length-zip-rainjacket-sgry-ns812842-812842-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_812842',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'HORN_HOODIE_HOODIE_UNISEX',
    model: 'Horn Hoodie',
    category: 'Hoodie',
    gender: 'Unisex',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'BLACK_DARK_GREY',
        colorLabel: 'Black / Dark Grey',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/4ViBthyDrUSfektyT441Vx/f1e7a0e2068cd8bdfa71407f8b805cbc/800003160900_13_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/7Bg0mqx0hqrFBMewJPMqOc/226ed0639b50b58a452f2a5b0076ddd1/800003160900_13_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/4ViBthyDrUSfektyT441Vx/f1e7a0e2068cd8bdfa71407f8b805cbc/800003160900_13_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/horn-hoody-top-blk-dgry800003160900-800003160900-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003160900',
        imageAlt: undefined,
      },
      {
        id: 'CARDINAL_DARK_CARDINAL',
        colorLabel: 'Cardinal / Dark Cardinal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2i0zowIlAq6M65yZFtvXql/14b7e89295c9af3987154fb832cfcd0c/800003161400_14_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5bKrCLlgzVRLeaEJuSvRiW/8c1da5e613a11a656ab98fc0d28c41fe/800003161400_14_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2i0zowIlAq6M65yZFtvXql/14b7e89295c9af3987154fb832cfcd0c/800003161400_14_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/horn-hoody-top-crd-dcrd800003161400-800003161400-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003161400',
        imageAlt: undefined,
      },
      {
        id: 'GREEN_DARK_GREEN',
        colorLabel: 'Green / Dark Green',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/RYZbILZQGipn94Li72PBV/64661715889e405df5ad4ccfc47108e9/800003160400_12_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6vBid8pVE3eO4crMZ9rCGl/aaa4a883d9efb11d90f8e7e7e431ebff/800003160400_12_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/RYZbILZQGipn94Li72PBV/64661715889e405df5ad4ccfc47108e9/800003160400_12_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/horn-hoody-top-grn-dgrn800003160400-800003160400-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003160400',
        imageAlt: undefined,
      },
      {
        id: 'NAVY_LIGHT_NAVY',
        colorLabel: 'Navy / Light Navy',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/oTu6z8QjPsKY85fUofk0A/95faa08ef5558e64376d7c2f765b4d98/800003160700_10_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2rcEWuON9Q7eqiamntlJ4r/5368d188671f21e2f2633b062341b472/800003160700_10_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/oTu6z8QjPsKY85fUofk0A/95faa08ef5558e64376d7c2f765b4d98/800003160700_10_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/horn-hoody-top-nav-lnav800003160700-800003160700-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003160700',
        imageAlt: undefined,
      },
      {
        id: 'ROYAL_DARK_ROYAL',
        colorLabel: 'Royal / Dark Royal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1Kr3PKOQmOK3407yq6qwVt/cce869ed779345708516e10ebad3ad9c/800003160300_11_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2qGwGAswrUDTgjRelPhVlk/a8879c83e2ef57fe87533fea5134302a/800003160300_11_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1Kr3PKOQmOK3407yq6qwVt/cce869ed779345708516e10ebad3ad9c/800003160300_11_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/horn-hoody-top-roy-droy800003160300-800003160300-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003160300',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'ISEN_1_4_ZIP_TOP_QUARTER_ZIP_UNISEX',
    model: 'Isen 1/4 Zip Top',
    category: 'Quarter Zip',
    gender: 'Unisex',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'BLACK_DARK_GREY',
        colorLabel: 'Black / Dark Grey',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/4bI9Asbo4s38HxhERR0DsW/98fb806d2a44a39c2a3c87aedee71e14/800003100900_4_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/4r4DEmR2Gid0x1miXpfu5G/595575d02bbd47591c65a2f569a959bc/800003100900_4_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/4bI9Asbo4s38HxhERR0DsW/98fb806d2a44a39c2a3c87aedee71e14/800003100900_4_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/isen-1-4-zip-top-blk-dgry800003100900-800003100900-0000121059?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003100900',
        imageAlt: undefined,
      },
      {
        id: 'CARDINAL_DARK_CARDINAL',
        colorLabel: 'Cardinal / Dark Cardinal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5zFPNrasp4VQY3ned5nmQy/17ecadd44de0862833c27323e1b53159/800003101400_5_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6nP2BG7kcCw4BeJKbWga1k/45e41662d4d653b25b2830b0d574c425/800003101400_5_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5zFPNrasp4VQY3ned5nmQy/17ecadd44de0862833c27323e1b53159/800003101400_5_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/isen-1-4-zip-top-crd-dcrd800003101400-800003101400-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003101400',
        imageAlt: undefined,
      },
      {
        id: 'GREEN_DARK_GREEN',
        colorLabel: 'Green / Dark Green',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1Go8RbnN6AaxubN7HX5Qrl/18b844e78a732ccfcd0d78d8439f5bcf/800003100400_3_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/65j8cEKRq0S7I31znaGdyQ/4e5b934991e179311e121c670f445107/800003100400_3_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1Go8RbnN6AaxubN7HX5Qrl/18b844e78a732ccfcd0d78d8439f5bcf/800003100400_3_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/isen-1-4-zip-top-grn-dgrn800003100400-800003100400-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003100400',
        imageAlt: undefined,
      },
      {
        id: 'NAVY_LIGHT_NAVY',
        colorLabel: 'Navy / Light Navy',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1SxAy4bxC1lE0EPFhcrTgY/7ba247bf48dd494cd2e8e4bb2d20c4ff/800003100700_1_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2LhDxB2GMMast3ssP344V5/d2de1c9a272d18a71a7624a3beea91a1/800003100700_1_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1SxAy4bxC1lE0EPFhcrTgY/7ba247bf48dd494cd2e8e4bb2d20c4ff/800003100700_1_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/isen-1-4-zip-top-nav-lnav800003100700-800003100700-0000121059?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003100700',
        imageAlt: undefined,
      },
      {
        id: 'ROYAL_DARK_ROYAL',
        colorLabel: 'Royal / Dark Royal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6YssBIyL9STInpM2ZLBf0O/e95248bf6b5341da04fdb9d2b4463b3e/800003100300_2_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2iJp3R49LyDl05iKnffX6s/8e6c8497384551e7a444d05e012e99a7/800003100300_2_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6YssBIyL9STInpM2ZLBf0O/e95248bf6b5341da04fdb9d2b4463b3e/800003100300_2_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/isen-1-4-zip-top-roy-droy800003100300-800003100300-0000121059?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003100300',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'JAZZ_POLO_POLO_UNISEX',
    model: 'Jazz Polo',
    category: 'Polo',
    gender: 'Unisex',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'ANTHRACITE_MELANGE',
        colorLabel: 'Anthracite / Melange',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1lXV1WVePYW6PEd0OCM7vm/d39c321a580e3e161f7d91613562033c/800003062800_17_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1wgsZXQXRCvz94NbqekGfC/0071bace39af38de98d38c2eac393437/800003062800_17_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1lXV1WVePYW6PEd0OCM7vm/d39c321a580e3e161f7d91613562033c/800003062800_17_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/jazz-polo-ant-mel800003062800-800003062800-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003062800',
        imageAlt: undefined,
      },
      {
        id: 'NAVY_MELANGE',
        colorLabel: 'Navy Melange',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/49kIdr6wA8eMXX9arQFyKM/e5e0b28e11f9aacbe811c556d69f5525/800003060700_15_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2qBHhEN9WQB8PdYS2pH9Y2/1ffd04458ea1d6c5450a7c8e07ac52b2/800003060700_15_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/49kIdr6wA8eMXX9arQFyKM/e5e0b28e11f9aacbe811c556d69f5525/800003060700_15_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/jazz-polo-navmel800003060700-800003060700-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003060700',
        imageAlt: undefined,
      },
      {
        id: 'ROYAL_MELANGE',
        colorLabel: 'Royal / Melange',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1AnmfJgw6huQrOL7UGcLiZ/112b4efd16c00addbb4b8fb70f852c90/800003060300_16_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2bwGibAs8sYqzY6tMbOIjN/c93fbbde45204da7f9a4211d370b94b4/800003060300_16_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1AnmfJgw6huQrOL7UGcLiZ/112b4efd16c00addbb4b8fb70f852c90/800003060300_16_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/jazz-polo-roy-mel800003060300-800003060300-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003060300',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'LENA_1_4_ZIP_TOP_QUARTER_ZIP_WOMEN',
    model: 'Lena 1/4 Zip Top',
    category: 'Quarter Zip',
    gender: 'Women',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'BLACK_DARK_GREY',
        colorLabel: 'Black / Dark Grey',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/15rUIG8LpMCVkU0F5melMU/8ad653dd6813bd52bfd71c5207049d35/800003110900_20_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5FcKJLc5XAW4ub5oo5bb8B/7f23ea7bc5eff1794fe423549057d2a2/800003110900_20_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/15rUIG8LpMCVkU0F5melMU/8ad653dd6813bd52bfd71c5207049d35/800003110900_20_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/lena-wmn-1-4-zip-top-blk-dgry800003110900-800003110900-0000121059?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003110900',
        imageAlt: undefined,
      },
      {
        id: 'NAVY_LIGHT_NAVY',
        colorLabel: 'Navy / Light Navy',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3XBjQ71fhdGBqfsZzs44Iw/795136e6c253fff9959358888187f076/800003110700_19_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/7uSPHGqUSfZRlHxIIGJb0G/278959dd64093622ad02b2bc5f20dfe6/800003110700_19_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3XBjQ71fhdGBqfsZzs44Iw/795136e6c253fff9959358888187f076/800003110700_19_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/lena-wmn-1-4-zip-top-nav-lnav800003110700-800003110700-0000121059?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003110700',
        imageAlt: undefined,
      },
      {
        id: 'ROYAL_DARK_ROYAL',
        colorLabel: 'Royal / Dark Royal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/64fG2bmc6MxmmQfh6olEO/22256a8c62515f1f711b5e228b23ff00/800003110300_18_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5ZcBfgJVrekCIrSr9B3Rtw/bf423dda8393ac0fb874ff882798f45b/800003110300_18_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/64fG2bmc6MxmmQfh6olEO/22256a8c62515f1f711b5e228b23ff00/800003110300_18_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/lena-wmn-1-4-zip-top-roy-droy800003110300-800003110300-0000121059?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003110300',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'MELODY_POLO_POLO_WOMEN',
    model: 'Melody Polo',
    category: 'Polo',
    gender: 'Women',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'NAVY_WHITE',
        colorLabel: 'Navy / White',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/40NElDc81uvUr1iLYEr8Vg/327a6b96bed3abfb105d2aba01995ce0/800003010701_31_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/7aqO2HBONc1HjR2YGM2Kvn/02c07dcd445cffc884a7d8b087e750ba/800003010701_31_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/40NElDc81uvUr1iLYEr8Vg/327a6b96bed3abfb105d2aba01995ce0/800003010701_31_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/melody-polo-wmn-ss-nav-wht800003010701-800003010701-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003010701',
        imageAlt: undefined,
      },
      {
        id: 'ROYAL_WHITE',
        colorLabel: 'Royal / White',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5G8HmJUvxrFZT6GmWJGrbB/498a6b293d8dd5b3496d817618bb9dbd/800003010301_32_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/69JnMukkhIc6Jftm5Efzwp/a2b62f7df2df36f2aea1035da3699594/800003010301_32_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5G8HmJUvxrFZT6GmWJGrbB/498a6b293d8dd5b3496d817618bb9dbd/800003010301_32_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/melody-polo-wmn-ss-roy-wht800003010301-800003010301-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003010301',
        imageAlt: undefined,
      },
      {
        id: 'WHITE_GREY',
        colorLabel: 'White / Grey',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5a2PdxtSt6bIWC2PAf32wq/0d01beecb14011d05e4945dabcec610c/800003010119_33_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5mI9opoeMkJkwxFDTFndRy/21563ec1f1552c4695df6fa5607a976a/800003010119_33_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/5a2PdxtSt6bIWC2PAf32wq/0d01beecb14011d05e4945dabcec610c/800003010119_33_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/melody-polo-wmn-ss-wht-gry800003010119-800003010119-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003010119',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'TAKEOFF_BACKPACK_BAG_UNISEX',
    model: 'Takeoff Backpack',
    category: 'Bag',
    gender: 'Unisex',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'NAVY',
        colorLabel: 'Navy',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/7BQdwY3lWHYFyiGe5YzZVd/227cb2fb55b913449db3c1b6bb2f17bf/3030690_30_01.png',
        backImageUrl: '',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/7BQdwY3lWHYFyiGe5YzZVd/227cb2fb55b913449db3c1b6bb2f17bf/3030690_30_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/takeoff-backpack-nav3030690-3030690-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_3030690',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'YARUGA_1_4_ZIP_TOP_QUARTER_ZIP_UNISEX',
    model: 'Yaruga 1/4 Zip Top',
    category: 'Quarter Zip',
    gender: 'Unisex',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'BLACK_DARK_GREY',
        colorLabel: 'Black / Dark Grey',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/4PeUV32JxMXQVK6X9iH4cI/772bdc1cb663a5320b0b759548e194ec/800002780900_36_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/41e2Ip1QGub4KGBUR1DAH9/44e35db3fe8f80c5fa7248679107c0c3/800002780900_36_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/4PeUV32JxMXQVK6X9iH4cI/772bdc1cb663a5320b0b759548e194ec/800002780900_36_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/yaruga-1-4-zip-top-blk-dgry800002780900-800002780900-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800002780900',
        imageAlt: undefined,
      },
      {
        id: 'CARDINAL_DARK_CARDINAL',
        colorLabel: 'Cardinal / Dark Cardinal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2kaLnK22FPCSfOfBrPiTDC/fab4df834cedf0fe65a26e59babd34f6/800002781400_35_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/6YnBORc44BNb4CLPn6yeht/ae445abf8d705ee6421f0c0fa2519271/800002781400_35_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/2kaLnK22FPCSfOfBrPiTDC/fab4df834cedf0fe65a26e59babd34f6/800002781400_35_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/yaruga-1-4-zip-top-crd-dcrd800002781400-800002781400-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800002781400',
        imageAlt: undefined,
      },
      {
        id: 'NAVY_LIGHT_NAVY',
        colorLabel: 'Navy / Light Navy',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/22ynuFzT5PbPw7pWiZ7tkc/05019b4dce3b6ce457f724dccf1b436a/800002780700_34_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/1gZdMRLsnMzfB2DoGsR6DM/209fb1238587685d48e937126edd2dd8/800002780700_34_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/22ynuFzT5PbPw7pWiZ7tkc/05019b4dce3b6ce457f724dccf1b436a/800002780700_34_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/yaruga-1-4-zip-top-nav-lnav800002780700-800002780700-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800002780700',
        imageAlt: undefined,
      },
      {
        id: 'ROYAL_DARK_ROYAL',
        colorLabel: 'Royal / Dark Royal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/263MfkltoGiOC6m7XAdzWp/b463630df6ccaff23f6a91d8fa1047ce/800002780300_37_01.png',
        backImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3O4e2NjXeGFxvfZXNc3Pa9/42629824383daedecb65f600eda7a3a7/800002780300_37_02.png',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/263MfkltoGiOC6m7XAdzWp/b463630df6ccaff23f6a91d8fa1047ce/800002780300_37_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/yaruga-1-4-zip-top-roy-droy800002780300-800002780300-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800002780300',
        imageAlt: undefined,
      },
    ],
  },
  {
    id: 'ZIMA_BEANIE_HEADWEAR_UNISEX',
    model: 'Zima Beanie',
    category: 'Headwear',
    gender: 'Unisex',
    title: undefined,
    description: undefined,
    variants: [
      {
        id: 'BLACK',
        colorLabel: 'Black',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3vRFonZxX9L03BYgZ3Jgq7/87ab23855e912c331f66d384aac2b5f8/800003090900_40_01.png',
        backImageUrl: '',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/3vRFonZxX9L03BYgZ3Jgq7/87ab23855e912c331f66d384aac2b5f8/800003090900_40_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/zima-beanie-jr-5-pz-blk-ns800003090900-800003090900-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003090900',
        imageAlt: undefined,
      },
      {
        id: 'NAVY',
        colorLabel: 'Navy',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/iUtbUc2qfQei1rLmv1uEn/17975255638a88bb08d0da5ecb552bb5/800003090700_38_01.png',
        backImageUrl: '',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/iUtbUc2qfQei1rLmv1uEn/17975255638a88bb08d0da5ecb552bb5/800003090700_38_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/zima-beanie-jr-5-pz-nav-ns800003090700-800003090700-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003090700',
        imageAlt: undefined,
      },
      {
        id: 'ROYAL',
        colorLabel: 'Royal',
        frontImageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/Nmm1Giu8myL2soZ5CY0Yc/431ed912c2603670cf1009f91f9ff18b/800003090300_39_01.png',
        backImageUrl: '',
        imageUrl:
          'https://images.ctfassets.net/56u5qdsjym8c/Nmm1Giu8myL2soZ5CY0Yc/431ed912c2603670cf1009f91f9ff18b/800003090300_39_01.png',
        purchaseUrl:
          'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up/zima-beanie-jr-5-pz-roy-ns800003090300-800003090300-0000121059-121060?utm_source=pga_cart&utm_medium=internal_upsell&utm_campaign=upsell_merch_2026&utm_content=upsell_800003090300',
        imageAlt: undefined,
      },
    ],
  },
]

export default JRL_MERCH_CATALOG
